import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from '../context/GlobalContext';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { Card, Row, Col, Container, Button } from 'react-bootstrap';
import Cookies from 'js-cookie';
import SearchBar from '../components/SearchBar';
import HeroSection from '../components/HeroSection';

function Home() {
  const { contextState, contextFunctions } = useContext(GlobalContext);

  const { arr, arrJob, setArr, fetchStatus, setFetchStatus } = contextState;
  const [dataJob, setDataJob] = useState(null);
  const [queryTitle, setQueryTitle] = useState('');
  const [filter, setFilter] = useState({
    company_name: '',
    company_city: '',
    job_type: '',
  });

  const { renderData, handleDetail, showStatus } = contextFunctions;

  let user = '';
  if (Cookies.get('user')) {
    user = JSON.parse(Cookies.get('user'));
  }

  const searchChange = (event) => {
    setQueryTitle(event.target.value);
  };

  const submitSearch = (event) => {
    event.preventDefault();
    setArr(null);
    const search = arr.filter((el) => {
      return Object.values(el)
        .join(' ')
        .toLowerCase()
        .includes(queryTitle.toLowerCase());
    });
    setArr(search);
    setQueryTitle('');
  };

  const handleChangeFilter = (event) => {
    setFilter({ ...filter, [event.target.name]: event.target.value });
  };

  const handleFilter = (event) => {
    event.preventDefault();
    console.log(filter);
    setArr(null);
    const filtered = arr.filter((el) => {
      return (
        el.company_name === filter.company_name ||
        el.company_city === filter.company_city ||
        el.job_type === filter.job_type
      );
    });
    setArr(filtered);
    setFilter({ company_name: '', company_city: '', job_type: '' });
  };

  useEffect(() => {
    if (fetchStatus === true) {
      renderData();
    }
  }, [fetchStatus, setFetchStatus]);

  return (
    <div className="home">
      <div className="container-fluid pb-5">
        <HeroSection user={user} />
        <div className="container mb-5">
          <div className="container mt-3">
            <form onSubmit={submitSearch}>
              <div className="col-auto">
                <label htmlFor="title" className="form-label">
                  Search
                </label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  onChange={searchChange}
                  value={queryTitle}
                  placeholder="Cari Posisi..."
                />
              </div>
              <div className="float-right ">
                <button
                  className="btn btn-primary rounded-pill mt-2 float-end"
                  type="submit"
                >
                  Cari
                </button>
                <button
                  className="btn btn-danger rounded-pill mt-2 float-end"
                  type="submit"
                  onClick={() => setFetchStatus(true)}
                >
                  Reset Data
                </button>
              </div>
            </form>
          </div>

          <div className="container mt-5 mb-5">
            <h4 className="mt-3">Filter Data</h4>
            <form onSubmit={handleFilter}>
              <div className=" col-12">
                <label htmlFor="company_name" className="form-label">
                  Cari Perusahaan
                </label>
                <input
                  type="text"
                  name="company_name"
                  className="form-control"
                  onChange={handleChangeFilter}
                  value={filter.company_name}
                  placeholder="Cari Perusahaan..."
                />
              </div>
              <div className=" col-12">
                <label htmlFor="company_city" className="form-label">
                  Cari Kota
                </label>
                <input
                  type="text"
                  name="company_city"
                  className="form-control"
                  onChange={handleChangeFilter}
                  value={filter.company_city}
                  placeholder="Cari Kota..."
                />
              </div>
              <div className=" col-12">
                <label htmlFor="job_type" className="form-label">
                  Tipe Pekerjaan
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="job_type"
                  onChange={handleChangeFilter}
                  value={filter.job_type}
                  placeholder="Tipe Pekerjaan..."
                />
              </div>
              <div className="float-right">
                <button
                  className="btn btn-primary rounded-pill mt-2 float-end"
                  type="submit"
                >
                  Filter
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* <SearchBar {...query} change={searchChange} /> */}
        <Container className="mt-3">
          <Row>
            {arr !== null ? (
              arr.map((el) => (
                <Col key={el.id} xs={12} md={6} lg={4} className="g-4">
                  <div style={{ height: '100%' }} className="card text-wrap">
                    <Card.Img src={el.company_image_url} className="img-home" />
                    <Card.Body style={{ height: '100%' }} className="text-wrap">
                      <Card.Title className="text-center fw-bold">
                        {el.title}
                      </Card.Title>
                      <Card.Text className="mb-5">
                        <p className="fw-semibold mt-4">{el.company_name}</p>
                        {el.job_description}
                        <div className="d-flex mt-3 flex-column fst-normal">
                          <p>
                            #
                            <span className="text-decoration-underline">
                              {el.company_city}
                            </span>
                          </p>
                          <p>
                            #
                            <span className="text-decoration-underline">
                              {el.job_type}
                            </span>
                          </p>
                          <p>
                            #
                            <span className="text-decoration-underline">
                              {showStatus(el.job_status)}
                            </span>
                          </p>
                        </div>
                      </Card.Text>
                      <div className="d-flex justify-content-end">
                        <Button
                          variant="primary"
                          onClick={handleDetail}
                          className="btn-home"
                          value={el.id}
                        >
                          Lihat Posisi
                        </Button>
                      </div>
                    </Card.Body>
                  </div>
                </Col>
                //       <div className="card" style={{ width: 18 + 'rem' }}>
                //     <img src={el.company_image_url} className="card-img-top" />
                //     <div className="card-body">
                //       <h5 className="card-title">{el.title}</h5>
                //       <p className="card-text">{el.job_description}</p>
                //       <a href="#" className="btn btn-primary">
                //         Go somewhere
                //       </a>
                //     </div>
                //   </div>
              ))
            ) : (
              <p>tidak ada lowongan</p>
            )}
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Home;
